import React from "react";
import "./BikeShowcase.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import BikeShowCaseData from "../../ComponentAPI/bikeShowCaseAPI";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Navigation } from "swiper/modules"; 
import RightArrow from "../../images/right-arrow.svg"
import LeftArrow from "../../images/left-arrow.svg"
const BikeShowcase = () => {
  return (
    <section className="bike-show section-padding-sm" >
      <div className="bike-show__header">
        <h2>
          Meet MYBYK <span>PEDAL</span>
        </h2>
      </div>
      <div className="bike-show__slider">
     <div className="action-button">
     <button className="custom-prev">
        <img src={LeftArrow} alt=""/>
      </button>
      <button className="custom-next">
        <img src={RightArrow} alt=""/>
      </button>
     </div>
    <Swiper
        spaceBetween={0}
        slidesPerView={3}
        speed={1000}
        loop={false}
        navigation={{
          prevEl: ".custom-prev", 
          nextEl: ".custom-next", 
        }}
        modules={[Navigation]} 
        breakpoints={{
          1500: {
            slidesPerView: 3,
          },
          991: {
            slidesPerView: 3,
          },
          767: {
            slidesPerView: 2.3,
          },
          600: {
            slidesPerView: 1.9,
          },
          400: {
            slidesPerView: 1.5,
          },
          300: {
            slidesPerView: 1.4,
            spaceBetween: 5,
          },
          250: {
            slidesPerView: 1,
          },
        }}
      >
        {BikeShowCaseData.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="slide">
              <div className="slider__item">
                <figure>
                  <img src={item?.image} alt={item?.title} loading="eager"  />
                </figure>
                <p>{item?.title}</p>
                <span>{item?.description}</span>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    
      </div>
    </section>
  );
};

export default BikeShowcase;
